import PropTypes from 'prop-types'
import { Box, Flex, Grid, Text } from '@chakra-ui/react'
import { Topbar } from './Topbar'
import { SideMenu } from './SideMenu'

const IS_STAGING = process.env.REACT_APP_STAGING === 'true'
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000'

export const Layout = ({ children }) => {
  return (
    <>
      <Topbar />
      <Grid templateColumns="250px 1fr" mt="60px" minH="calc(100vh - 60px)">
        <SideMenu boxShadow="0px 1px 3px gray" />
        <Box p={4}>{children}</Box>
      </Grid>
      {IS_STAGING && (
        <Flex
          justifyContent="center"
          alignItems="center"
          px={2}
          position="fixed"
          bottom={0}
          width="100%"
          minHeight="50px"
          boxShadow="0px 1px 3px gray"
          zIndex={1000}
          bg="green.400"
        >
          <Text fontSize="md" color="white">This is a staging server. API requests are going to {API_URL}</Text>
        </Flex>
      )}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node
}
